import { useNavigate } from "react-router-dom"
import { useState,useEffect } from 'react';
import supabase from "../../supabaseClient";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Link from "@mui/material/Link";

import { Box, Select, MenuItem, FormControl, InputLabel, Accordion, AccordionSummary,CardContent,Card,Container, Checkbox,FormControlLabel } from '@mui/material';
import InfoNavBar from "../NavigationBar/InfoNavBar";
// import Footer from "../Info/Footer";

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
export let userEmail
export let userId


//navigate menu section
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'} variant={'body2'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
//end navigate
function Auth() {



 


//set translate
	
  const [showPassword, setShowPassword] = useState(false);

//menu tabs
const [value, setValue] = useState(0);

const handleChange = (event, newValue) => {
  setValue(newValue);
};
    const navigate = useNavigate()//add to nav

   const [email, setEmail] = useState(''); // email of the user
  const [password, setPassword] = useState(''); // password of the user
  const [username, setUsername] = useState(''); // username of the user
  const [Rmsg, setRMsg] = useState(''); // Registration message
  const [Lmsg, setLMsg] = useState(''); // Login message
  const [LmsgL, setLMsgL] = useState(''); // Login message via megic link
  const [Resetmsg, setResetMsg] = useState('');
  const [user, setUser] = useState(''); // User object after registration / login
  const [session, setSession] = useState(''); // session object after registration / login
  const [checkboxChecked, setCheckboxChecked] = useState(false); // terms and coditions

  useEffect(() => {
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      if (data?.session) {
        navigate('/home');
      }
    };
    checkSession();
  }, [navigate]);
  supabase.auth.onAuthStateChange((event,session) => {
    if (event == "SIGNED_IN") {
      navigate('/home')
      userEmail=session?.user.email;
      userId=session?.user.id;
      console.log(userId)
      // setter
localStorage.setItem('userIdFromLocalStorage', session?.user.id);
    }
  });
 
  const Register = async () => {
    // const {data, error} = await supabase.auth.signUp({
    //   email,
    //   password,
    // },
    // {
    //   data: {
    //     username
    //   }
    // })
    // if(error){
    //   setRMsg(error.message)
    // }else{
    //   setRMsg(t("Successful registration"))
    //   setUser(data.user)
    // }

    const { data, error } = await supabase.auth.signUp(
      {
        email: email,
        password: password,
        options: {
          data: {
            full_name: email,
          }
        }
      }
    )
    if(error){
      setRMsg(error.message)
    }else{
      setRMsg(("Prawidłowa rejestracja"))
      setUser(data.user)
    }

  }

let errorMessageLogin=("Enter correct data")
const Login = async () => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  console.log("📥 LOGIN RESPONSE:", { data, error });

  if (error) {
    setLMsg("❌ " + error.message);
  } else {
    setLMsg("✅ Zalogowano pomyślnie");
    setUser(data.user);
    setSession(data.session);
    navigate('/home');
  }
};
let ErrorMessageMagicLink=("Wprowadź poprawny adres e-mail")
  const SendMagicLink = async () => {
    const {user,error}=await supabase.auth.signInWithOtp({email})
    if(error){
        setLMsgL(ErrorMessageMagicLink)
      }else{
        setLMsgL(("Logowanie poprawne, sprawdź skrzynkę e-mail"))
    
      }
  }

return (
    <div className="App" >
<div>

{/* <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
  <div>
  <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            TaskVenue
          </Typography>
  </div>
</Box>

<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>

<div>&nbsp;</div>
<Language></Language>

</Box> */}

<InfoNavBar></InfoNavBar>







</div>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90vh',
      }} style={{ background: 'white',paddingTop: '14px' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} >
      <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            allowScrollButtonsMobile 
            variant="scrollable"
            scrollButtons
            sx={{ display: 'flex' }}
          >
          <Tab label={("Logowanie")} {...a11yProps(0)} />
          <Tab label={("Rejestracja")} {...a11yProps(1)} />
          <Tab label={("Magic link")} {...a11yProps(2)} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
      <Container maxWidth="md" style={{ padding: '16px' }}>
      <Card>
      <CardContent     sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
        <h1>{("Logowanie")}</h1>
        <TextField
          style={{ width: "250px" }}
          id="standard-basic"
          label={("E-mail")}
          placeholder={("Wprowadź adres e-mail")}
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          variant="standard"
        />
        <br />
        <TextField
          style={{ width: "250px" }}
          id="standard-password-input"
          label={("Hasło")}
          type={showPassword ? "text" : "password"}
          autoComplete="current-password"
          variant="standard"
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <br />
        <br />
        <Button size="large" variant="contained" style={{ minWidth: '250px' }} onClick={Login}>
          {("Zaloguj")}
        </Button>
        <p>{Lmsg}</p>
        <br />
        <Link onClick={() => handleChange(null, 2)}>{("Nie pamiętam hasła")}</Link>
        <Link onClick={() => handleChange(null, 1)}>{("Nie masz konta?")}  {("Zacznij tutaj")}</Link>
   
      </CardContent>
    </Card>
    </Container>
      </TabPanel>

      <TabPanel value={value} index={1}>
      <Container maxWidth="md" style={{ padding: '16px' }}>
      <Card>
      <CardContent     sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <h1>{("Rejestracja")}</h1>
         <TextField style={{ width: "250px" }} id="standard-basic" label={("Wprowadź adres e-mail")}variant="standard" onChange={(e) => 
        setEmail(e.target.value)} />
      <br/>
      <TextField
          style={{ width: "250px" }}
          id="standard-password-input"
          label={("Wprowadź hasło")}
          type={showPassword ? "text" : "password"}
          autoComplete="current-password"
          variant="standard"
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
           <br/>
        {/* <TextField id="standard-basic" label="Imie" variant="standard" onChange={(e) => 
        setUsername(e.target.value)} /> */}
         
          <FormControlLabel
          control={<Checkbox onChange={(e) => setCheckboxChecked(e.target.checked)} />}
          label={
            <Link
            onClick={() => navigate('/termsAndConditions')} // Kliknij, aby nawigować do '/termsAndConditions'
          >
            {("Akceptuję regulamin")}
          </Link>
          }
        />
        <br />

      <Button size="large" variant="contained" style={{ minWidth: '250px'}} onClick={Register}   disabled={!checkboxChecked}  >{("Zarejestruj")}</Button>
      <p>{Rmsg}</p>
      </CardContent>
    </Card>
    </Container>
      </TabPanel>

      <TabPanel value={value} index={2}>
      <Container maxWidth="md" style={{ padding: '16px' }}>
      <Card>
      <CardContent     sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <h1>{("Magic Link")}</h1>

      <br/>
      <TextField style={{ width: "250px" }} id="standard-basic" label={("E-mail")} placeholder={("Wprowadź adres e-mail")}  type="email" onChange={(e) => setEmail(e.target.value)} variant="standard" />
      <br/> 

      <FormControlLabel
          control={<Checkbox onChange={(e) => setCheckboxChecked(e.target.checked)} />}
          label={
            <Link
            onClick={() => navigate('/termsAndConditions')} // Kliknij, aby nawigować do '/termsAndConditions'
          >
            {("Akceptuję regulamin")}
          </Link>
          }
        />
         
      <br/> 
      <Button size="large" variant="contained" style={{ minWidth: '250px'}} disabled={!checkboxChecked}  onClick={SendMagicLink}>{("Wyślij Magic link")}</Button>
      <p>{LmsgL}</p>
      </CardContent>
    </Card>
    </Container>
      </TabPanel>
    </Box>
    {/* <Footer style={{ position: 'fixed', bottom: 0, width: '100%' }}></Footer> */}
    </div>
  );
      }
export default Auth;
